module.exports = {
      id: "audio-music-usage",
      viewBox: "0 0 24 24",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#audio-music",
      toString: function () {
        return this.url;
      }
    }